export default __webpack_public_path__ + "static/media/failure-med.2ca29e00.431dd499.svg";